import { render, staticRenderFns } from "./editOrganization.vue?vue&type=template&id=6abca258&"
import script from "./editOrganization.vue?vue&type=script&lang=js&"
export * from "./editOrganization.vue?vue&type=script&lang=js&"
import style0 from "./editOrganization.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports